
import S3 from 'react-aws-s3'

export const config = {
  bucketName: 'nural-sales-document-bucket',
  region: 'ap-south-1',
  accessKeyId: 'AKIA3PJWQQNQFJLPW6EH',
  secretAccessKey: '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',
}

export const handleMultipleFiles = (e, setProgress = ()=>{}, form, setForm, ) => {
  let arrImages = []
  // console.log('NAME : ', e.target.name)

  Object.keys(e.target.files).forEach((key) => {
    let img = e.target.files[key]
    setProgress(true)

    const ReactS3Client = new S3(config)
    ReactS3Client.uploadFile(img, `product-images/${Math.random()}${img.name}`)
      .then((data) => {
        setProgress(false)
        arrImages.push(data.location)
        // handleChange([...arrImages])
        setForm({ ...form, [e.target.name]: [...arrImages] })
        //console.log(arrImages)
      })
      .catch((err) => {
        setProgress(false)
      })
  })
}

export const handleSingleFile = (e, setProgress = ()=>{}, form, setForm, ) => {
    let img = e.target.files[0]
    setProgress(true)
    
    const ReactS3Client = new S3(config)
    // alert("file function")
    ReactS3Client.uploadFile(img, `product-images/${Math.random()}${img.name}`)
      .then((data) => {
        setProgress(false)
        let image = (data.location)
        console.log("image", image)
        console.log(e.target.name)
        setForm({ ...form, [e.target.name]: image })
      })
      .catch((err) => {
        setProgress(false)
      })
}